import { useProductContext } from "../../context/ProductContext";
import { useCartContext } from "../../context/CartContext";
import Slider from "../../components/Slider";
import SingleProduct from "../../components/SingleProduct";

const Home = () => {
  const { featureProducts, isLoading } = useProductContext();
  const { addToCart, addToOrder } = useCartContext();

  return (
    <>
      <Slider />

      <section id="product1" className="section-p1">
        <h2 style={{ textAlign: "center", fontWeight: "bold" }}>
          FEATURED PRODUCTS
        </h2>

        <div className="pro-container">
          {isLoading ? (
            <h5>Loading......</h5>
          ) : (
            featureProducts.map((item, index) => {
              return (
                <SingleProduct
                  key={index}
                  item={item}
                  addToCart={addToCart}
                  addToOrder={addToOrder}
                />
              );
            })
          )}
        </div>
      </section>
    </>
  );
};

export default Home;
